import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const deleteAdminSupplierRow = createApi(`DeleteAdminSupplierSlice`,"DELETE");

const DeleteAdminSupplierSlice = createSlice({
  name: 'DeleteAdminSupplierSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteAdminSupplierRow.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAdminSupplierRow.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteAdminSupplierRow.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DeleteAdminSupplierSlice.reducer;